import styled from 'styled-components'

export const ChartTypeSelectorContainer = styled.div`
  display: flex;
  gap: 0.5rem;
`
